import axios, { resHandle } from "@/plugins/axios";
import axios2 from 'axios';
/**
 * @description 上传图片
 * @param vCom Vue组件
 */
const UploadImage = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/image", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch(() => {
            if (loading) {
                loading.close();
            }
            reject();
        });
    });
};
/**
 * @description 上传视频
 * @param vCom Vue组件
 */
const UploadVideo = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/file", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 上传文件
 * @param vCom Vue组件
 */
const UploadFile = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/file", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};

/**
 * @description 专病库列表
 * @param vCom Vue组件
 */
const GetCenter = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/list").then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 创建人列表
 * @param vCom Vue组件
 */
const CreatorList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/creators", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 获取目录式控件的选项
 * @param vCom Vue组件
 */
const GetMulu = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/mulu").then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 术语搜素（西医疾病、中医疾病、治法治则、中医证型、中医症状）
 * @param vCom Vue组件
 */
const GetTerms = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/terms", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @desc 获取面图数据
 */
const getFaceAnalysisData = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/zwb/face/ai/detail', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @desc 保存面图数据
 */
const PostFaceAnalysisData = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/zwb/face/ai/detail', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @desc 上传舌图(不分析，只是上传)
 * @param params 参数{"project_id":"","shemian":"","shedi":"","patient_id":"","zhenci_id":""},shemian为url，shedi为url
 * @param loading 加载中
 */
const UploadTongue = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/zwb/tongue/ai/upload_all', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @desc 上传舌图(分析)
 * @param params 参数{"project_id":"","shemian":"","shedi":"","patient_id":"","zhenci_id":""},shemian为url，shedi为url
 * @param loading 加载中
 */
const UploadTongueAnalysis = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/zwb/tongue/ai/upload', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @desc 上传面图(不分析，只是上传)
 * @param params 参数{"project_id":"","mian":"","patient_id":"","zhenci_id":""},mian为文件
 * @param loading 加载中
 */
const UploadFace = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/zwb/face/ai/upload_all', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @desc 上传面图(分析)
 * @param params 参数{"project_id":"","mian":"","patient_id":"","zhenci_id":""},mian为文件
 * @param loading 加载中
 */
const UploadFaceAnalysis = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/zwb/face/ai/upload', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};

/**
 * @desc 语音转文字
 * @param params 参数{speech_url:''},speech_url为语音文件url
 * @param loading 加载中
 */
const VoiceToText = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        console.log('VoiceToText 开始请求，URL:', 'https://edc-test.medkg.cn/api/ai/speech/stt/', '参数:', params);
        axios2.post('https://edc-test.medkg.cn/api/ai/speech/stt/', params).then((response) => {
            const data = response.data;
            console.log('VoiceToText 响应数据:', data);
            console.log('响应数据类型:', typeof data);
            console.log('响应是否有 error_code:', typeof data?.error_code);
            console.log('error_code 值:', data?.error_code);

            // 如果响应有 error_code 字段且不为 0，使用 resHandle 处理
            if (data && typeof data.error_code !== 'undefined' && data.error_code !== 0) {
                console.log('响应包含 error_code 且不为 0，使用 resHandle 处理');
                resHandle(vCom, data, loading).then(() => {
                    console.log('resHandle 成功，返回数据:', data.data || data);
                    resolve(data.data || data);
                }).catch((err) => {
                    console.error('resHandle 失败:', err);
                    if (loading) {
                        loading.close();
                    }
                    reject(err);
                });
            } else {
                // 如果响应没有 error_code 字段，或者 error_code 为 0，直接返回数据
                console.log('响应不包含 error_code 或 error_code 为 0，直接返回数据:', data);
                if (loading) {
                    loading.close();
                }
                // 如果响应有 data 字段，返回 data，否则返回整个响应
                resolve(data?.data || data);
            }
        }).catch((err) => {
            console.error('VoiceToText 请求失败:', err);
            console.error('错误详情:', err.response?.data || err.message || err);
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @desc 修改报告配置
 * @param params 参数{
 * "show_comment": true, # 是否显示注释内容 true false
 * "cover_type": "",  # 封面默认还是自定义： default，custom
 * "cover_content": "",  # 自定义封面富文本
 * "user_id": ""  # 用户id
 * }
 * @param loading 加载中
 */
const UpdateReportConfig = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/project/report/config', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        });
    });
};
/**
 * @desc 查看报告配置
 * @param params 参数{
 * "user_id": ""  # 用户id
 * }
 * @param loading 加载中
 */
const GetReportConfig = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/project/report/config', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        });
    });
};

export {
    UploadImage, UploadVideo, GetCenter, CreatorList, GetMulu, GetTerms,
    getFaceAnalysisData, PostFaceAnalysisData, UploadFile,
    UploadTongue, UploadTongueAnalysis, UploadFace, UploadFaceAnalysis,
    VoiceToText,
    UpdateReportConfig, GetReportConfig,
}